import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { FooterModule } from 'app/partials/footer/footer.module';
import { IconsModule } from 'app/wipperoz-core/icons/icons.module';
import { StartModule } from 'app/wipperoz-core/start/start.module';
import { MainNavbarModule } from '../main-navbar/main-navbar.module';
import { ContentItemComponent } from './content-item.component';

@NgModule({
  declarations: [ContentItemComponent],
  imports: [CommonModule, RouterModule, FormsModule, StartModule, FooterModule, MainNavbarModule, IconsModule],
  exports: [ContentItemComponent]
})
export class ContentItemModule {}
